import { render } from "./DailyDosesModal.vue?vue&type=template&id=760b7081&scoped=true"
import script from "./DailyDosesModal.vue?vue&type=script&lang=js"
export * from "./DailyDosesModal.vue?vue&type=script&lang=js"

import "./DailyDosesModal.vue?vue&type=style&index=0&id=760b7081&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760b7081"]])

export default __exports__